<template>
  <div class="userPoster" v-if="loading">
    <template v-if="poster">
      <p>↓点击放大图片，长按数秒，保存后分享给好友，邀请好友扫码注册</p>
      <div class="poster_img" id="myImage">
        <div class="poster_box">
          <img :src="poster" alt="" />
        </div>
      </div>
      <p>↑点击放大图片，长按数秒，保存后分享给好友，邀请好友扫码注册</p>
    </template>

    <van-empty v-else description="暂无海报" />
    <div class="custom_btn return" @click="handleReturn">
      <i class="iconfont icon-yuyinjiantou"></i> 返回
    </div>
  </div>
</template>

<script>
import { getCompanyInfo, getPosterTkid, getPosterImg } from "../../api/company";
import { mapState } from "vuex";
export default {
  name: "userRegisterPoster",
  data() {
    return {
      loading: false,
      poster: null,
    };
  },
  computed: {
    ...mapState(["OPENID", "USERINFO", "userAgent", "qy_userId"]),
  },
  created() {
    this.getCompanyInfo();
  },
  methods: {
    handleReturn() {
      this.$router.back();
    },

    // 获取企业
    async getCompanyInfo() {
      const toast = this.$toast.loading({
        message: "请稍后...",
        forbidClick: true,
      });
      let that = this;
      let qyInfo = await getCompanyInfo({ openid: this.OPENID });
      console.log(qyInfo, "=====qyInfo");

      if (qyInfo.postappid) {
        let params = {
          appid: qyInfo.postappid,
          qyguid: qyInfo.guid,
          intro_openid: this.USERINFO.openid,
          intro_truename: this.USERINFO.truename,
        };
        // 获取海报的tkid
        let poster = await getPosterTkid(params);
        // console.log(poster, "==posterposterposter");

        // 根据tkid获取海报
        let base64Img = await getPosterImg(poster.code);

        const reader = new FileReader();
        reader.readAsDataURL(base64Img);
        reader.onloadend = function () {
          that.poster = reader.result;
          // 在此处使用 base64Data 进行后续操作，如显示图片或发送给服务器等
        };
      } else {
        that.poster = ''
      }

      toast.clear();
      that.loading = true;
    },
  },
};
</script>
<style lang="less" scoped>
.userPoster {
  padding: 85px 0 240px;
  box-sizing: border-box;
  p {
    font-size: 22px;
    color: #ff0030;
    text-align: center;
    white-space: nowrap;
  }
  .poster_img {
    margin: 30px auto;
    width: 650px;
    position: relative;
    min-height: 600px;
    .ercode_box {
      position: absolute;
      right: 50px;
      bottom: 50px;
      width: 140px;
    }
  }
  .custom_btn {
    margin-top: 60px;
  }
}
</style>